<div class="container-fluid p-0" class="p-4">
  <div class="h5">
    Financial Report Types
  </div>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="row">
    <dx-data-grid
      [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true"
      [cellHintEnabled]="false"
      [columnAutoWidth]="true"
      [dataSource]="dataSource"
      (onRowClick)="onSelectionChanged($event.data)"
    >
      <dxo-editing mode="cell" [refreshMode]="'full'" [allowDeleting]="canEdit()"> </dxo-editing>
      <dxi-column caption="Name" dataField="name">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
      <dxo-paging [pageSize]="5"></dxo-paging>
    </dx-data-grid>
  </div>
</div>

<div class="mt-3 p-3" *ngIf="selectedRaw">
  <div>
    <b>Type info</b>
    <div class="row">
      <div class="col-5">
        <mat-form-field style="margin: 0px !important;">
          <mat-label>Type name</mat-label>
          <input matInput [(ngModel)]="selectedRaw.name" />
        </mat-form-field>
      </div>
      <button class="col-2" mat-raised-button color="primary" (click)="saveUnit(selectedRaw)">Save</button>
    </div>
  </div>
  <div class="drag-container w-100">
    <b>Columns</b>
    <div class="row">
      <div class="col-6">
        <mat-form-field style="margin: 0px !important;">
          <mat-label>New column name</mat-label>
          <input matInput [(ngModel)]="newColumnName" />
        </mat-form-field>
      </div>
      <button class="add-column-button" mat-fab color="primary" (click)="addColumn()"><mat-icon>add</mat-icon></button>
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="drag-list mt-2">
      <div class="drag-box d-flex" *ngFor="let item of selectedRaw.financialReportColumns" cdkDrag>
        <div class="col-1">
          <mat-icon>
            drag_indicator
          </mat-icon>
        </div>
        <div class="col-5">Name: {{ item.name }}</div>
        <div class="col-4">Order: {{ item.order }}</div>
        <div class="col-4">
          <mat-form-field>
            <input
              [(ngModel)]="item.endDate"
              (focus)="picker.open()"
              [matDatepicker]="picker"
              matInput
              placeholder="End date"
              (ngModelChange)="updateDate(item)"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-2" (click)="removeColumn(item)" style="z-index: 1000;"><mat-icon>delete</mat-icon></div>
      </div>
    </div>
  </div>
</div>
